import { DEFAULT_ORDERS_LIST_PARAMETERS } from '@entities/order/config/store-constants';
import { DEFAULT_REQUESTS_LIST_PARAMETERS } from '@entities/request/config/store-constants';

export const DEFAULT_ORDERS_SIDE_LIST_PARAMETERS = {
    ...DEFAULT_ORDERS_LIST_PARAMETERS,
    take: 3,
};

export const DEFAULT_REQUESTS_SIDE_LIST_PARAMETERS = {
    ...DEFAULT_REQUESTS_LIST_PARAMETERS,
    take: 3,
};
